import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

import { AlertRulesFiltersState, AlertRulesSortDirection, AlertRulesSortState } from '../../models';
import { checkCategoryFiltersOptions, toggleFilterSelection, updateFiltersWithNestedItems } from '../../utils';
import { CheckAllCategoryOptionsAction, UpdateFilterAction, UpdateFiltersWithNestedItemsAction } from '../alerts.types';

export interface AlertsRulesState {
  isAlertRulesFiltersSidebarOpen: boolean;
  alertRulesSearchValue: string;
  selectedAlertsRulesFiltersPerCategory: AlertRulesFiltersState;
  alertRulesSortValue: AlertRulesSortState;
}

const initialState: AlertsRulesState = {
  isAlertRulesFiltersSidebarOpen: appStorage.getIsAlertRulesFiltersSidebarOpen() ?? true,
  alertRulesSearchValue: '',
  selectedAlertsRulesFiltersPerCategory: {},
  alertRulesSortValue: {
    field: 'createdAt',
    direction: AlertRulesSortDirection.Desc,
  },
};

export const alertsRulesSlice = createSlice({
  name: 'alertsRules',
  initialState,
  reducers: {
    toggleIsAlertRulesFiltersSidebarOpenAction(state) {
      state.isAlertRulesFiltersSidebarOpen = !state.isAlertRulesFiltersSidebarOpen;
    },

    setAlertRulesSortAction(state, action: PayloadAction<AlertRulesSortState>) {
      state.alertRulesSortValue = action.payload;
    },

    setAlertRulesSearchValueAction(state, action: PayloadAction<string>) {
      state.alertRulesSearchValue = action.payload;
    },

    toggleFilterSelectionForAlertsRulesAction(state, action: PayloadAction<UpdateFilterAction>) {
      const { categoryKey, optionKey } = action.payload;

      if (!categoryKey || !optionKey) return;

      toggleFilterSelection(state.selectedAlertsRulesFiltersPerCategory, action.payload);

      appStorage.setIsAlertsPolling(false);
    },

    checkCategoryOptionsForAlertsRulesAction(state, action: PayloadAction<CheckAllCategoryOptionsAction>) {
      checkCategoryFiltersOptions(state.selectedAlertsRulesFiltersPerCategory, action.payload);
    },

    updateFiltersWithNestedItemsForAlertsRulesAction(state, action: PayloadAction<UpdateFiltersWithNestedItemsAction>) {
      updateFiltersWithNestedItems(state.selectedAlertsRulesFiltersPerCategory, action.payload);
    },

    clearAllAlertsRulesFiltersAction(state) {
      state.selectedAlertsRulesFiltersPerCategory = initialState.selectedAlertsRulesFiltersPerCategory;
    },
  },
});

export const {
  toggleIsAlertRulesFiltersSidebarOpenAction,
  setAlertRulesSearchValueAction,
  setAlertRulesSortAction,
  updateFiltersWithNestedItemsForAlertsRulesAction,
  toggleFilterSelectionForAlertsRulesAction,
  checkCategoryOptionsForAlertsRulesAction,
  clearAllAlertsRulesFiltersAction,
} = alertsRulesSlice.actions;
